export default __webpack_public_path__ + "static/media/paddelPlayerwb.7a78ebab.png";